import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import Genres from './components/genres/genres';
import CopyBox from './components/bbcode/copy-box';

import Avatar from './components/upload/avatar';
import Cover from './components/upload/cover';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';

import './css/profile.css';
import { ButtonGroup } from 'react-bootstrap';

export default class Settings extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			imageadd: false,
			coveradd: false,
			profile: decodeURI(window.location.pathname.match(/\/settings\/(.*)/)[1]),
			user: {},
			user_temp: {},
			setting: '',
			notice: '',
			error: '',

			genre: '',
			genres: {},
			genrelist: {},
			genreshow: false,
			genrepicker: [],

			password: {
				current: '',
				new: '',
				valid: false,
				error: '',
				visible: false,
			},

			recover: false,
			recover_url: '',

			email: [],

			donation: {}, // this is the current working one on the website
			donations: {}, // this is the list received from the api
			/*donation: {
				type: 0,
				status: 1,
				option1: '',
				option2: '',
				option3: '',
				option4: '',
			}*/
		};
		this.loadProfile = this.loadProfile.bind(this);
		this.imageAdd = this.imageAdd.bind(this);
		this.coverAdd = this.coverAdd.bind(this);
		this.complete = this.complete.bind(this);
		this.close = this.close.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.changeSetting = this.changeSetting.bind(this);
		this.showPassword = this.showPassword.bind(this);
		this.saveSettings = this.saveSettings.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
		this.resendEmail = this.resendEmail.bind(this);
		this.deleteEmail = this.deleteEmail.bind(this);
		this.handleChangeDonation = this.handleChangeDonation.bind(this);
		this.saveSettingDonation = this.saveSettingDonation.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params2 = new URLSearchParams();
		const y = await postApi('/api/v2/schedule/prepare', params2);
		this.setState({genres: y.data.genres});

		this.loadProfile();
	}

	componentWillUnmount() {
	}

	async loadProfile() {
		var params = new URLSearchParams();
		params.append( 'profile', this.state.profile );
		const x = await postApi('/api/v2/profile', params);
		if( x.status === 200 ) {
			let username = x.data.User.username.toLowerCase();
			document.title = username.charAt(0).toUpperCase() + username.slice(1) + " Profile - Mix365 Radio";
			this.setState({status: true, user: x.data.User, genrepicker: (x.data.User.genres.length>0?x.data.User.genres.split(','):[]), email: x.data.Email, donations: x.data.Donations});
		} else {
			//this.props.history.push('/');
			//this.location = '/';
			return;
		}
	}

	imageAdd() {
		this.setState({imageadd: !this.state.imageadd});
	}

	coverAdd() {
		this.setState({coveradd: !this.state.coveradd});
	}

	complete() {
		this.close();
		this.componentDidMount();
	}

	close() {
		this.setState({imageadd: false, coveradd: false, recover: false});
	}



	handleChange(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		let user = this.state.user_temp;
		if( event.target.name === "rank" ) user.id_level = parseInt(item);
		if( event.target.name === "email" ) user.email = item;
		if( event.target.name === "cur_password" ) {
			let password = this.state.password;
			password.current = item;
			this.setState({password});
		}
		if( event.target.name === "new_password" ) {
			//const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\s]).{8,40}$/;
			let password = this.state.password;
			password.new = item;
			password.valid = decimal.test(String(item));
			if( !password.valid ) {
				password.error = '* Capital letter, Number and a Special character required';
			} else {
				password.error = ''
			}
			if(item.length < 8 || item.length > 40 ) {
				password.valid = false;
				password.error = '* Must be between 8 and 40 characters';
			}
      this.setState({password});
		}

		if( event.target.name === "title" ) user.title = item;
		if( event.target.name === "biography" ) user.biography = item;
		if( event.target.name === "donation" ) user.donation = item;
		if( event.target.name === "country" ) user.country = item;
		if( event.target.name === "facebook" ) user.facebook = item;
		if( event.target.name === "hearthisat" ) user.hearthisat = item;
		if( event.target.name === "instagram" ) user.instagram = item;
		if( event.target.name === "mixcloud" ) user.mixcloud = item;
		if( event.target.name === "soundcloud" ) user.soundcloud = item;
		if( event.target.name === "twitch" ) user.twitch = item;
		if( event.target.name === "youtube" ) user.youtube = item;
		if( event.target.name === "coffee" ) user.coffee = item;
		if( event.target.name === "notifications" ) user.notifications = item;
		if( event.target.name === "discord" ) user.discord = item;
		if( event.target.name === "genre" ) this.setState({genre: item, genreshow: (item.length>=4?true:false)}, () => {
			if( item.length>=4 ) {

				var _new = {};
				for( let i in this.state.genres ) {
					for( let j in this.state.genres[i] ) {
						let search = new RegExp(`(${item.replace(' ','|')})`,"gi");
						if( this.state.genres[i][j].match(search) != null ) {
							if( !_new[i] ) _new[i] = [];
							_new[i].push(this.state.genres[i][j]);
						}
					}
				}
				this.setState({genrelist: _new});
			}
		});
		this.setState({user_temp: user});
	}

	changeSetting(setting) {
		if(this.state.setting===setting) {
			this.setState({setting: '', notice: '', error: ''});
		} else {
			this.setState({setting, notice: '', error: '', user_temp: {...this.state.user}});
		}
	}

	showPassword() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}

	async saveSettings(e) {
		e.preventDefault();
		var params = new URLSearchParams();
		params.append( 'setting', this.state.setting );
		params.append( 'uid', this.state.user.uid );
		if( this.state.setting==='rank') params.append( 'rank', this.state.user_temp.id_level );
		if( this.state.setting==='email') params.append( 'email', this.state.user_temp.email );
		if( this.state.setting==='password') {
			params.append( 'cur_password', this.state.password.current );
			params.append( 'new_password', this.state.password.new );
		}
		if( this.state.setting==='title') params.append( 'title', this.state.user_temp.title );
		if( this.state.setting==='biography') params.append( 'biography', this.state.user_temp.biography );
		if( this.state.setting==='donation') params.append( 'donation', this.state.user_temp.donation );
		if( this.state.setting==='country') params.append( 'country', this.state.user_temp.country );

		if( this.state.setting==='notifications') params.append( 'notifications', this.state.user_temp.notifications );
		if( this.state.setting==='discord') params.append( 'discord', this.state.user_temp.discord );

		if( this.state.setting==='genres') params.append( 'genres', this.state.genrepicker );
		if( this.state.setting==='socials') params.append( 'facebook', this.state.user_temp.facebook.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'hearthisat', this.state.user_temp.hearthisat.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'instagram', this.state.user_temp.instagram.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'mixcloud', this.state.user_temp.mixcloud.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'soundcloud', this.state.user_temp.soundcloud.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'twitch', this.state.user_temp.twitch.toLowerCase() );
		if( this.state.setting==='socials') params.append( 'youtube', this.state.user_temp.youtube.toLowerCase() );
		let x = await putApi('/api/v2/profile/edit', params);
		if( x.status===200) {
			if( this.state.setting==='password' ) {
				window.location.href = '/login';
			} else {
				this.setState({setting: '', notice: '', error: ''},()=>{this.loadProfile()});
			}
		} else if( x.status===201) {
		} else if( x.status===213) {
			this.setState({notice: x.data.message},()=>{this.loadProfile()});
		} else {
			this.setState({error: x.data.message});
		}
		//this.props.history.push(`/profile/${this.state.profile}`);
	}


	async resetPassword(id) {
		let params = new URLSearchParams();
		params.append('uid', id);
		let x = await putApi('/api/v2/admin/djaccountsRecover', params);
		this.setState({recover: true, recover_url: x.data.url});
	}

	selectGenre(genre) {
		let pick = this.state.genrepicker;
		for( let i in pick ) if( genre === pick[i] ) return;
		pick.push(genre);
		this.setState({genre: '', genreshow: false, genrepicker: pick});
	}

	removeGenre(genre) {
		let pick = this.state.genrepicker;
		for( let i in pick ) if( genre === pick[i] ) pick.splice( i, 1 );
		this.setState({genrepicker: pick});
	}

	async resendEmail(email) {
		let params = new URLSearchParams();
		params.append('email', email);
		await postApi('/api/v2/profile/resendemail', params);
		this.loadProfile();
	}

	async deleteEmail(email) {
		let params = new URLSearchParams();
		params.append('email', email);
		await deleteApi('/api/v2/profile/deleteemail', params);
		this.loadProfile();
	}

	editDonation(type) {
		if( type === -1 ) {
			this.setState({donation: {}});
		} else {
			if( this.state.donations[type] ) {
				this.setState({donation: {...this.state.donations[type]}});
			} else {
				this.setState({donation: { type, status: 1, option1: '', option2: '', option3: '', option4: '' }});
			}
		}
	}

	

	handleChangeDonation(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		let donation = this.state.donation;
		if( event.target.name === "option1" ) donation.option1 = item;
		if( event.target.name === "option2" ) donation.option2 = item;
		if( event.target.name === "status" ) donation.status = event.target.checked?1:0;
		this.setState({donation});
	}

	async saveSettingDonation(e) {
		e.preventDefault();
		var params = new URLSearchParams();

		params.append('type', this.state.donation.type);
		params.append('status', this.state.donation.status);
		params.append('option1', this.state.donation.option1);
		params.append('option2', this.state.donation.option2);
		params.append('option3', this.state.donation.option3);
		params.append('option4', this.state.donation.option4);

		let x = await putApi('/api/v2/profile/donation', params);
		if( x.status === 200 ) {
			this.setState({donations: x.data, donation: {}});
		}
	}

	render() {
		const user = this.context;
		const genrelist = 
			Object.keys(this.state.genrelist).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<div>{e}</div>
						<div style={{marginLeft: -5}}>
						{(() => {
							return Object.keys(this.state.genrelist[e]).map((f,j) => {
								return (
									<div key={j} style={{margin: 3, paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, backgroundColor: 'rgb(76, 80, 95)', borderRadius: 20, float: 'left', cursor: 'pointer'}} onClick={() => this.selectGenre(this.state.genrelist[e][f])}>{this.state.genrelist[e][f]}</div>
								)
							})
						})()}
					</div>
					<div style={{clear: 'both'}}></div>
				</React.Fragment>
			)})
		const genrepick = 
			Object.keys(this.state.genrepicker).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<div style={{margin: 3, paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, backgroundColor: 'rgb(76, 80, 95)', borderRadius: 20, float: 'left', cursor: 'pointer'}} onClick={() => this.removeGenre(this.state.genrepicker[e])}>{this.state.genrepicker[e]}&nbsp;<i className="fa fa-times"></i></div>
					</React.Fragment>
				)})
			const email = Object.keys(this.state.email).map((e,i) => {
				return (
					<InputGroup key={i} className="mt-2 mb-1">
						<Form.Control value={this.state.email[i].email} disabled />
						<Button disabled={Math.floor(Date.now()/1000)<this.state.email[i].ctime+60?true:false} onClick={()=>this.resendEmail(this.state.email[i].email)}>Resend Email</Button>
						<Button onClick={()=>this.deleteEmail(this.state.email[i].email)}>Delete</Button>
					</InputGroup>
				)})
		return (
			<>
				{this.state.status && this.state.user &&
					<>
						<div className="profile-intro" style={{backgroundImage: `url(https://mix365.co.uk${this.state.user.cover}`}}>
							<div className="profile-background"></div>
						</div>

						<div className="profile-article">
							<div className="" style={{paddingTop: 0, paddingBottom: 0}}>
							
								<Row className="">
									<Col>
										<div style={{position: 'relative'}}>
											<div style={{position: 'absolute', right: 30, bottom: 10}}>
												<Button size="sm" onClick={this.coverAdd}><FontAwesomeIcon icon="image" /> Upload Cover</Button>
											</div>
										</div>
									</Col>
								</Row>

								<Row className="profile">
									<Col xs={1} className="d-none d-md-block"></Col>
									<Col xs={4} className="profile-block">
										<div className="profile-avatar">
											<div className="profile-avatar-inner">
												<img src={`https://mix365.co.uk${this.state.user.avatar}`} alt="Profile Avatar" />
											</div>
										</div>
									</Col>
									<Col className="pt-2 ps-4">
										<Row className="gx-0">
											<Col xs={12} md={6}>
												{this.state.user.title?this.state.user.title:this.state.user.username}<br />
												{this.state.user.level}{/*<br />
												0 Followers*/}
											</Col>
											<Col className="pt-2 pe-5 text-right">
												<ButtonGroup size="sm">
													{/*this.state.user?.uid !== user.user?.user?.id &&
														<Button onClick={()=>this.friends(this.state.user.uid)}>{this.state.user.friend===1?<>Following <FontAwesomeIcon icon="check" /></>:<>Follow</>}</Button>
													}
													<Button size="sm">Share</Button>*/}
													<Link to={`/${this.state.profile}`}><Button size="sm">Return to Profile</Button></Link>
												</ButtonGroup>
											</Col>
										</Row>
									</Col>
								</Row>
							</div>
						</div>

						<div className="profile-splitter text-center" style={{marginTop: 312}}>
							<div className="profile-splitter-background"></div>
							<h2 className="profile-splitter-text">
								
							</h2>
						</div>

						<div className="article">
							<Row>
								<Col md={2}>
									<div className="weeklydjs-card" style={{}}>
										<div className="weeklydjs-avatar" style={{position: 'relative'}}>
											<img src={`https://mix365.co.uk/${this.state.user.avatar}`} alt="DJ Profile Avatar" className="weeklydjs-avatar-img" width="100%" />
											<div className="profile-upload-profile">
												<Button size="sm" onClick={this.imageAdd}><FontAwesomeIcon icon="image" /> Upload</Button>
											</div>
										</div>
										<Row className="home-nl-bottom gx-0">
											<Col xs={12}>
												{this.state.user.title?this.state.user.title:this.state.user.username}<br />
											</Col>
											<Col xs={12} className="profile-country">
												<FontAwesomeIcon icon="location-dot" /> {this.state.user.country_default.replace('/',', ')}<br />
												<FontAwesomeIcon icon={['far', 'clock']} /> {moment(this.state.user.joined*1000).format("Do MMMM YYYY")}
											</Col>
							
											<Col xs={12}>
												<ul className="weeklydjs-socials">
													{this.state.user.facebook &&
														<li>
															<a href={this.state.user.facebook} title="Facebook" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
															</a>
														</li>
													}
													{/*<li>H</li>*/}
													{this.state.user.instagram &&
														<li>
															<a href={this.state.user.instagram} title="Instagram" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.mixcloud &&
														<li>
															<a href={this.state.user.mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.soundcloud &&
														<li>
															<a href={this.state.user.soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.twitch &&
														<li>
															<a href={this.state.user.twitch} title="Twitch" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.youtube &&
														<li>
															<a href={this.state.user.youtube} title="Youtube" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
															</a>
														</li>
													}
												</ul>
											</Col>
										</Row>
									</div>
								</Col>
								<Col>
									
									{user.user?.admin?.admin_access&&
										<>
											<h3 className="profile-header">Rank</h3>
											<Col>
												<div className="profile-edit">
													<Button size="sm" onClick={()=>this.changeSetting('rank')}><FontAwesomeIcon icon="bars" /></Button>
												</div>
												{this.state.user.level}<br />
												{this.state.setting==='rank'&&
													<Form>
														<Form.Control className="col-md-6" as="select" name="rank" onChange={this.handleChange} defaultValue={this.state.user_temp.id_level}>
															<option value="1">Banned</option>
															<option value="2">Pending</option>
															<option value="10">Member</option>
															<option value="15">Subscriber</option>
															<option value="20">Radio DJ</option>
															<option value="21">Clubber DJ</option>
															<option value="30">Junior Admin</option>
															<option value="31">Admin</option>
															<option value="32">Owner</option>
														</Form.Control>
														<ButtonGroup size="sm">
															<Button size="sm" className="btn-success" onClick={this.saveSettings}>Save</Button>
															<Button size="sm" className="btn-danger" onClick={()=>this.changeSetting('')}>Cancel</Button>
														</ButtonGroup>
													</Form>
												}
											</Col>
										</>
									}

									<h3 className="profile-header">Email</h3>
									<Col>
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('email')}><FontAwesomeIcon icon="bars" /></Button>
											{this.state.user.id_level===2&&
												<Button size="sm" className="btn-success" onClick={()=>this.resendEmail(this.state.user.email)}>Resend Email</Button>
											}
										</div>
										{this.state.user.email}<br />
										{this.state.setting==='email'&&
											<Form onSubmit={this.saveSettings}>
												<Form.Control className="col-md-6" type="email" name="email" onChange={this.handleChange} defaultValue={this.state.user_temp.email} placeholder="Enter email" />
												
												{this.state.notice.length>0&&
													<><strong className="">* {this.state.notice}</strong><br /></>
												}
												{this.state.error.length>0&&
													<><strong className="profile-error">* {this.state.error}</strong><br /></>
												}
												<ButtonGroup size="sm">
													<Button size="sm" onClick={this.saveSettings}>Save</Button>
													<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
												</ButtonGroup>
											</Form>
										}
										{this.state.user.id_level===2 ?
											<>
												<strong>Unverified</strong>, To verify your email address, click the button within your email to verify this email address.<br />
											</>
										:
											<>
												{this.state.email.length > 0 &&
													<Row>
														<Col md={8}>
															{email}
														</Col>
														<Col xs={12}>
															To verify your email address, click the button within your email to verify this email address.
														</Col>
													</Row>
												}
											</>
										}
										
									</Col>
								

									<h3 className="profile-header">Password</h3>
									<Col>
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('password')}><FontAwesomeIcon icon="bars" /></Button>
										</div>
										Change Password<br />
										{this.state.setting==='password'&&
											<Row className="pt-3">
												<Col lg={6}>
													<Form onSubmit={this.saveSettings}>
														{/*<label htmlFor='cur_password'>Current Password</label>
														<Form.Control className="col" type="password" name="cur_password" id="cur_password" onChange={this.handleChange} placeholder="Enter current password" />*/}
														<label htmlFor='new_password'>New Password</label>
														<span className="float-right">
															{this.state.password.new.length > 0 &&
																<>
																	{this.state.password.valid ?
																		<span className="" style={{backgroundColor: '#008800', borderRadius: '50%', padding: '0px 4px 2px 4px', color: '#ffffff', fontSize: 12}}><FontAwesomeIcon icon="check" /></span>
																	:
																		<span style={{color:"#d71362", fontSize: 14, fontWeight: 600}}>
																			{this.state.password.error}
																		</span>
																	}
																</>
															}
														</span>
														<InputGroup className="mb-2">
															<Form.Control className="col" type={this.state.password.visible?'text':'password'} name="new_password" id="new_password" onChange={this.handleChange} placeholder="Enter new password" />
															<InputGroup.Text style={{background: 'rgba(144,144,144,0.07)', border: 'none', cursor: 'pointer'}} onClick={this.showPassword}>
																<FontAwesomeIcon icon="eye" style={{color:'#ffffff'}} />
															</InputGroup.Text>
														</InputGroup>
														<ButtonGroup size="sm">
															<Button size="sm" onClick={this.saveSettings}>Save</Button>
															<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
														</ButtonGroup>
													</Form>
												</Col>
												{user.user?.admin?.admin_access &&
													<Col xs={12} className="pt-2">
														<Button size="sm" onClick={()=>{this.resetPassword(this.state.user.uid)}}>Send Recovery Email</Button>
													</Col>
												}
											</Row>
										}
									</Col>

									<h3 className="profile-header">Display Name</h3>
									<Col>
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('title')}><FontAwesomeIcon icon="bars" /></Button>
										</div>
										{this.state.user.title?this.state.user.title:this.state.user.username}<br />
										{this.state.setting==='title'&&
											<Form onSubmit={this.saveSettings}>
												<Form.Control className="col-4" type="text" name="title" onChange={this.handleChange} defaultValue={this.state.user_temp.title} placeholder={this.state.user_temp.username} />
												Leave blank to display your username<br />
												<ButtonGroup size="sm">
													<Button size="sm" onClick={this.saveSettings}>Save</Button>
													<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
												</ButtonGroup>
											</Form>
										}
									</Col>

									<h3 className="profile-header">Notifications</h3>
									<Col>
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('notifications')}><FontAwesomeIcon icon="bars" /></Button>
										</div>
										{this.state.user.notifications===0?'Notifications disabled':'Receive email notifications'}<br />
										{this.state.setting==='notifications'&&
											<Form onSubmit={this.saveSettings}>
												<Form.Check className="col-4 mb-2" type="radio" name="notifications" value="0" defaultChecked={this.state.user.notifications===0} onChange={this.handleChange} label="Disable notification" />
												<Form.Check className="col-4 mb-2" type="radio" name="notifications" value="1" defaultChecked={this.state.user.notifications===1} onChange={this.handleChange} label="Receive email notification" />
												<ButtonGroup size="sm">
													<Button size="sm" onClick={this.saveSettings}>Save</Button>
													<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
												</ButtonGroup>
											</Form>
										}
									</Col>
								
									{user.user?.admin?.mod_access &&
										<>
											<h3 className="profile-header">Donations</h3>
											<Col>
												<div className="profile-edit">
													<Button size="sm" onClick={()=>this.changeSetting('donation')}><FontAwesomeIcon icon="bars" /></Button>
												</div>
												{this.state.user.donation?this.state.user.donation:'Write a thank you note to ask for donations'}<br />
												{this.state.setting==='donation'&&
													<Form>
														<Form.Control as="textarea" rows="4" className="col-8" name="donation" onChange={this.handleChange} defaultValue={this.state.user_temp.donation} placeholder="" />
														<ButtonGroup size="sm">
															<Button size="sm" onClick={this.saveSettings}>Save</Button>
															<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
														</ButtonGroup>
													</Form>
												}
											</Col>
											<Col xs={12}>
												<Row className="gx-0 my-4">
													<Col className="text-center">
														<a href="https://www.paypal.com/donate/buttons" target="_blank" rel="noreferrer">
															<img src="/images/paypal.png" alt="Donate via Paypal" width="30%" /><br />
															https://www.paypal.com
														</a><br />
														<Button size="sm" className="mt-2" onClick={()=>this.editDonation(1)}>
															{this.state.donations[1]?.status === 1 ?
																<>Paypal Active <FontAwesomeIcon icon="check" /></>
															:
																<>Setup Paypal Donation</>
															}
														</Button>
													</Col>
													<Col className="text-center">
														<a href="https://ko-fi.com/" target="_blank" rel="noreferrer">
															<img src="/images/ko-fi.png" alt="Donate via Ko-fi" width="30%" /><br />
															https://ko-fi.com
														</a><br />
														<Button size="sm" className="mt-2" onClick={()=>this.editDonation(2)}>
															{this.state.donations[2]?.status === 1 ?
																<>Ko-Fi Active <FontAwesomeIcon icon="check" /></>
															:
																<>Setup Ko-Fi Donation</>
															}
														</Button>
													</Col>
												</Row>
											</Col>

											{Object.keys(this.state.donation).length > 0 && this.state.donation.type === 1 &&
												<Col xs={12}>
													<Form>
														Paypal Donation Link:<br />
														<Form.Control className="col-4 mb-2" type="text" name="option1" onChange={this.handleChangeDonation} defaultValue={this.state.donation.option1} placeholder="https://www.paypal.com/donate/?hosted_button_id=" />
														Optional*<br />
														Minimum Donation Amount: (please include curreny symbol) <br />
														<Form.Control className="col-4 mb-2" type="text" name="option2" onChange={this.handleChangeDonation} defaultValue={this.state.donation.option2} placeholder="£3.00" />
														<Form.Check className="col-4 mb-2" type="checkbox" name="status" onChange={this.handleChangeDonation} defaultChecked={this.state.donation.status===1&&'checked'} label="Active" />
														<ButtonGroup size="sm">
															<Button size="sm" onClick={(e)=>this.saveSettingDonation(e)}>Save</Button>
															<Button size="sm" onClick={()=>this.editDonation(-1)}>Cancel</Button>
														</ButtonGroup>
													</Form>
												</Col>
											}

											{Object.keys(this.state.donation).length > 0 && this.state.donation.type === 2 &&
												<Col xs={12}>
													<Form>
														Ko-Fi Donation Link:<br />
														<Form.Control className="col-4 mb-2" type="text" name="option1" onChange={this.handleChangeDonation} defaultValue={this.state.donation.option1} placeholder="https://ko-fi.com/" />
														Optional*<br />
														Minimum Donation Amount: (please include curreny symbol) <br />
														<Form.Control className="col-4 mb-2" type="text" name="option2" onChange={this.handleChangeDonation} defaultValue={this.state.donation.option2} placeholder="£3.00" />
														<Form.Check className="col-4 mb-2" type="checkbox" name="status" onChange={this.handleChangeDonation} defaultChecked={this.state.donation.status===1&&'checked'} label="Active" />
														<ButtonGroup size="sm">
															<Button size="sm" onClick={(e)=>this.saveSettingDonation(e)}>Save</Button>
															<Button size="sm" onClick={()=>this.editDonation(-1)}>Cancel</Button>
														</ButtonGroup>
													</Form>
													<br />
													First Option:<br />
												</Col>
											}
										</>
									}
									
									<h3 className="profile-header">About</h3>
									<Col>
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('biography')}><FontAwesomeIcon icon="bars" /></Button>
										</div>
										{this.state.user.biography?this.state.user.biography:'Write something about you'}<br />
										{this.state.setting==='biography'&&
											<Form>
												<Form.Control as="textarea" rows="5" className="col-8" name="biography" onChange={this.handleChange} defaultValue={this.state.user_temp.biography} placeholder="" />
												<ButtonGroup size="sm">
													<Button size="sm" onClick={this.saveSettings}>Save</Button>
													<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
												</ButtonGroup>
											</Form>
										}
									</Col>

									{user.user?.admin?.mod_access &&
										<>
											<h3 className="profile-header">Location</h3>
											<Col>
												<div className="profile-edit">
													<Button size="sm" onClick={()=>this.changeSetting('country')}><FontAwesomeIcon icon="bars" /></Button>
												</div>
												{this.state.user.country_default}<br />
												{this.state.setting==='country'&&
													<Form onSubmit={this.saveSettings}>
														<Form.Control className="col-lg-6" type="text" name="country" onChange={this.handleChange} defaultValue={this.state.user_temp.country} placeholder={this.state.user.country_default} />
														Leave blank to display your GeoIP Location<br />
														<ButtonGroup size="sm">
															<Button size="sm" onClick={this.saveSettings}>Save</Button>
															<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
														</ButtonGroup>
													</Form>
												}
											</Col>
										

											<h3 className="profile-header">Main Genres</h3>
											<Col>
												<div className="profile-edit">
													<Button size="sm" onClick={()=>this.changeSetting('genres')}><FontAwesomeIcon icon="bars" /></Button>
												</div>
												
												{this.state.setting==='genres' ?
													<>
														<Form.Control type="text" name="genre" id="genre" value={this.state.genre} onChange={this.handleChange} className="col-lg-6" placeholder="Search Genres">
														</Form.Control>
														{this.state.genreshow &&
															<div style={{position: 'absolute', top: 33, width: '96%', backgroundColor: 'rgb(52, 57, 75)', fontSize: 14, maxHeight: 250, overflowY: 'scroll', zIndex:1}}>
																<div style={{padding: 10}}>
																	{genrelist}
																</div>
															</div>
														}
														<div style={{fontSize:14, paddingTop: 5}}>
															{genrepick}
														</div>
														{/*<Genres genres={this.state.user.genres} />*/}<br /><br />
														<ButtonGroup size="sm">
															<Button size="sm" onClick={this.saveSettings}>Save</Button>
															<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
														</ButtonGroup>
													</>
													: 
													<><Genres genres={this.state.user.genres} /><br /></>
												}
											</Col>
										</>
									}

									
									<h3 className="profile-header">Socials</h3>
									<Col className="pb-5">
										<div className="profile-edit">
											<Button size="sm" onClick={()=>this.changeSetting('socials')}><FontAwesomeIcon icon="bars" /></Button>
										</div>
										{this.state.setting==='socials'&&
											<Form>
												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="facebook" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Facebook</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="facebook" id="facebook" value={this.state.user_temp.facebook} onChange={this.handleChange} className="form-control-sm" placeholder="https://www.facebook.com/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="hearthisat" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Hearthisat</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="hearthisat" id="hearthisat" value={this.state.user_temp.hearthisat} onChange={this.handleChange} className="form-control-sm" placeholder="https://hearthis.at/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="instagram" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Instagram</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="instagram" id="instagram" value={this.state.user_temp.instagram} onChange={this.handleChange} className="form-control-sm" placeholder="https://www.instagram.com/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="mixcloud" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Mixcloud</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="mixcloud" id="mixcloud" value={this.state.user_temp.mixcloud} onChange={this.handleChange} className="form-control-sm" placeholder="https://www.mixcloud.com/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="soundcloud" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Soundcloud</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="soundcloud" id="soundcloud" value={this.state.user_temp.soundcloud} onChange={this.handleChange} className="form-control-sm" placeholder="https://soundcloud.com/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="twitch" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Twitch</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="twitch" id="twitch" value={this.state.user_temp.twitch} onChange={this.handleChange} className="form-control-sm" placeholder="https://www.twitch.tv/" />
													</div>
												</div>

												<div className="form-group row pt-2 pb-0 mb-2">
													<label htmlFor="youtube" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Youtube</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control type="text" name="youtube" id="youtube" value={this.state.user_temp.youtube} onChange={this.handleChange} className="form-control-sm" placeholder="https://www.youtube.com/" />
													</div>
												</div>
												<ButtonGroup size="sm">
													<Button size="sm" onClick={this.saveSettings}>Save</Button>
													<Button size="sm" onClick={()=>this.changeSetting('')}>Cancel</Button>
												</ButtonGroup>

											</Form>
										}
									</Col>
									
								</Col>
							</Row>

						</div>


						
					</>
				}
				{this.state.imageadd && <Avatar show={this.state.imageadd} close={this.close} complete={()=>{this.complete();}} uid={this.state.user.uid} /> }
				{this.state.coveradd && <Cover show={this.state.coveradd} close={this.close} complete={()=>{this.complete();}} uid={this.state.user.uid} /> }

				<Modal show={this.state.recover} onHide={this.close} backdrop="static" keyboard={false} size="lg" centered>
					<Modal.Header closeButton className="bg-dark">
						<Modal.Title>Email Sent</Modal.Title>
					</Modal.Header>
					<Modal.Body className="bg-dark">
						An email has been sent to the member with a link to change their password. Alternatively you can pass this url:
						<CopyBox content={this.state.recover_url} />
					</Modal.Body>
					<Modal.Footer className="bg-dark">
						<Button variant="secondary" onClick={this.close}>
							Close
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		);
	}
}
